import React from 'react';
import { Link } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import LanguageToggle from './../../core/language-toggle/LanguageToggle';
import './Landing.scss';

class Landing extends React.Component {
	render() {
		return (
			<div className="Landing">
				<div className="container">
					<div className="simpleMenu">
						<LanguageToggle />
					</div>
					<div>
						<Link to="/signup">Signup</Link> | <Link to="/signin">Signin</Link>
					</div>

					<h1>Landing</h1>
					<p>
						Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus ornare sem nec est elementum porttitor. Nam ultricies, quis pharetra justo dui eleifend tortor.
						<br />
						<br />
						Aliquam suscipit vulputate lorem, eget cursus odio euismod vitae. Mauris quam.
					</p>
				</div>
			</div>
		);
	}
}
export default withTranslation()(Landing);
